import React from "react";
import { DatePicker } from "antd";
import dayjs from "dayjs";
import "../App.css"
const { RangePicker } = DatePicker;

const BasicDateRange = ({ onDateChange, defaultRange }) => {
  const handleChange = (value) => {
    if (value && value.length === 2) {
      onDateChange(value);
    } else {
      onDateChange({ startDate: null, endDate: null });
    }
  };
  // Disable future dates
  const disabledDate = (current) => {
    return current && current > dayjs().endOf("day");
  };

  return (
    <div className="p-2 max-md:p-0 max-md:w-full max-md:min-w-0">
      <RangePicker
        onChange={handleChange}
        disabledDate={disabledDate}
        className="custom-range-picker max-md:w-full"
        defaultValue={defaultRange}
      />
    </div>
  );
};

export default BasicDateRange;
